export type TTheme = 'light' | 'dark'

class ThemeStorage {
  private readonly THEME_KEY = 'theme'
  private readonly DEFAULT_THEME: TTheme = 'light'

  public getTheme(): TTheme {
    try {
      const raw = localStorage.getItem(this.THEME_KEY)
      return raw === 'dark' ? 'dark' : this.DEFAULT_THEME
    } catch (error) {
      console.error('Ошибка при чтении темы:', error)
      return this.DEFAULT_THEME
    }
  }

  public setTheme(theme: TTheme): void {
    try {
      localStorage.setItem(this.THEME_KEY, theme)
    } catch (error) {
      console.error('Ошибка при сохранении темы:', error)
    }
  }
}

export const themeStorage = new ThemeStorage()
